export enum StudentAssignmentStatusEnum {
    TODO = "todo",
    PENDING = "pending",
    MARKED = "marked",
    MARKS_NOT_AVAILABLE = "marksNotAvailable",
    EXEMPTED = "exempted",
    RESUBMISSION_REQUIRED = "resubmissionRequired"
}
